import ReactDOM from "react-dom";

const PortalAwareItem = ({ ...props }) => {
  const child = props.child;
  const usePortal = props.usePortal;
  const portal = props.portal;

  if (!usePortal) {
    return child;
  }

  // if dragging - put the item in a portal
  return ReactDOM.createPortal(child, portal);
};

export default PortalAwareItem;
